// xor.js
import CryptoJS from 'crypto-js';

const key = (process.env.SECRET_KEY || 'aRandomSecretKey');
const encoder = new TextEncoder();
const decoder = new TextDecoder();

/** XOR‑помощник */
const xorBytes = (bytes, keyBytes) =>
  bytes.map((b, i) => b ^ keyBytes[i % keyBytes.length]);

/** Генерация случайной строки из a‑zA‑Z0‑9 длиной len */
export const randString = (len) => {
  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  return Array.from({ length: len }, () =>
    alphabet[Math.floor(Math.random() * alphabet.length)]
  ).join('');
};

/** Base64 encode URL-friendly */
const base64urlEncode = (bytes) =>
  btoa(String.fromCharCode(...bytes))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');

/** Base64 decode URL-friendly */
const base64urlDecode = (base64url) => {
  let base64 = base64url.replace(/-/g, '+').replace(/_/g, '/');
  while (base64.length % 4) base64 += '=';
  const binary = atob(base64);
  return Uint8Array.from(binary.split('').map((c) => c.charCodeAt(0)));
};

/** SHA256 (синхронно через CryptoJS) */
const sha256 = (dataBytes) => {
  const wordArray = CryptoJS.lib.WordArray.create(dataBytes);
  const hash = CryptoJS.SHA256(wordArray);
  const hexString = hash.toString(CryptoJS.enc.Hex);
  return Uint8Array.from(hexString.match(/.{2}/g).map(byte => parseInt(byte, 16)));
};

/** HMAC-SHA256 (синхронно через CryptoJS) */
const hmacSha256 = (keyBytes, messageBytes) => {
  const keyWordArray = CryptoJS.lib.WordArray.create(keyBytes);
  const messageWordArray = CryptoJS.lib.WordArray.create(messageBytes);
  const hmac = CryptoJS.HmacSHA256(messageWordArray, keyWordArray);
  const hexString = hmac.toString(CryptoJS.enc.Hex);
  return Uint8Array.from(hexString.match(/.{2}/g).map(byte => parseInt(byte, 16)));
};

/** Encrypt (c ключом) */
export function encrypt(text, customKey = key) {
  const randomSuffix = encoder.encode(randString(32));
  const timestamp = encoder.encode(Math.floor(Date.now() / 1000).toString());
  const payload = new Uint8Array([
    ...encoder.encode(text),
    124, // '|'
    ...timestamp,
    124, // '|'
    ...randomSuffix
  ]);

  const keyBytes = encoder.encode(customKey);
  const suffixSignature = hmacSha256(keyBytes, randomSuffix);
  const dynamicKey = sha256(new Uint8Array([...keyBytes, ...randomSuffix]));

  const encryptedPayload = xorBytes(payload, dynamicKey);

  const final = new Uint8Array([
    ...randomSuffix,
    ...suffixSignature,
    ...encryptedPayload
  ]);

  return base64urlEncode(final);
}

/** Decrypt (синхронный!!!) */
export function decrypt(cipher, customKey = key) {
  let raw;
  try {
    raw = base64urlDecode(cipher);
  } catch {
    return null;
  }

  if (raw.length < (32 + 32)) {
    return null;
  }

  const randomSuffix = raw.slice(0, 32);
  const suffixSignature = raw.slice(32, 64);
  const encryptedPayload = raw.slice(64);

  const keyBytes = encoder.encode(customKey);
  const expectedSignature = hmacSha256(keyBytes, randomSuffix);

  if (!expectedSignature.every((b, i) => b === suffixSignature[i])) {
    return null;
  }

  const dynamicKey = sha256(new Uint8Array([...keyBytes, ...randomSuffix]));
  const decryptedBytes = xorBytes(encryptedPayload, dynamicKey);

  try {
    const decryptedText = decoder.decode(decryptedBytes);
    return decryptedText;
  } catch {
    return null;
  }
}
